import Chart from "react-apexcharts";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import ReactECharts from "echarts-for-react";
import { Stack } from "@mui/material";

const CostBreakdown = (props) => {

    const {data, nameField, valueField, currencySymbol} = props;

    const { t } = useTranslation();

    const total = data? data.reduce((partialSum, a) => partialSum + a[valueField], 0) : 1.0;

    let sortedData = data? [...data].sort((a, b)=>{return a[valueField] - b[valueField]}): []

    

    let x = []
    let y = []
    if (data){
        x = x.concat(sortedData.map((item)=>item[nameField]))
        y = y.concat(sortedData.map((item)=>item[valueField]))
    }

    
    

    const series = [
        {
          name: "Cost",
          data: y,
        }
    ];

    const options = {
        xAxis: {
        },
        yAxis: {
            type: 'category',
            data: x,
        },
        grid: {
            left: 120,
            right: 35,
            top: 0,
            bottom: 40
        },
        tooltip: {
            show: true,
            formatter: function(params) {
                return params.name + ': ' + currencySymbol + params.value.toFixed() 
            }
        },
        series: {
            type: "bar",
            data: y,
            itemStyle: {
                color: '#3788d8'
                },
            label: {
                show: true,   
                color: 'black',  
                fontSize: 10,  
                offset: [10, -5],
                formatter: function (params) {
                    return (params.value * 100 / total).toFixed(1) + '%'  
                },
            },
        },
        textStyle: {
            fontFamily: "Roboto, Helvetica, Arial, sans-serif" 
        }
    }
    
    return (
        <Stack overflowY={'auto'}>
            <ReactECharts option={options} style={{height: Math.max( 50*y.length + 50, 350)}}/> 
        </Stack>
        
    )

}

export default CostBreakdown;